"use client"
import { API_SUBMIT_ENDPOINT_URL, HOST_URL } from "@/libs/constants"
import { BlockType } from "@/libs/types"
import React from "react"
import LayoutForm from "../../LayoutForm"
import Company from "../../shared/Company"
import Content from "../../shared/Content"
import Telephone from "../../shared/Telephone"
import "./styles.css"
interface ContactusProps {
    locale: string,
    block: BlockType
}

const ContactusForm: React.FunctionComponent<ContactusProps> = ({ locale, block }) => {

    const [submited, updateSubmited] = React.useState<boolean>(false)

    const handleSubmit = async (values: any) => {
        const { firstname, lastname, email, company, department, title, country, phone, content } = values;

        const data: any = {
            firstname: firstname?.value,
            lastname: lastname?.value,
            email: email?.value,
            company: company?.value,
            department: department?.value,
            title: title?.value,
            country: country?.value,
            phone: phone?.value,
            content: content?.value,
            tracking: window.location.href,
            host: HOST_URL
        }
        const body = Object.keys(data).filter((k) => !!data[k]).map((k: string) => {
            if (data[k] && !!data[k] && data[k] !== "undefined")
                return encodeURIComponent(k) + '=' + encodeURIComponent(data[k])
        })

        let response = await fetch(`${API_SUBMIT_ENDPOINT_URL}/submit`, {
            method: 'POST',
            body: body.join('&'),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        });
        const { status } = await response.json()
        console.log(`status`, status)
        return status
    }

    return (
        <div className="under__attack__form__right">
            <LayoutForm
                title={block.title}
                callback={handleSubmit}
                updateSubmited={updateSubmited}
                locale={locale}
                submited={submited}
                className={block.classes}
            >
                <Telephone locale={locale} />
                <div className="row md-3">
                    <Company locale={locale} col={12} />
                    <Content locale={locale} />
                </div>
            </LayoutForm>
        </div>
    )
}

export default ContactusForm